import { render, staticRenderFns } from "./MultiPointObjectiveEditor.vue?vue&type=template&id=10933ede&"
import script from "./MultiPointObjectiveEditor.vue?vue&type=script&lang=ts&"
export * from "./MultiPointObjectiveEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports